import { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import FormStepModal from '#client/components/FormStepModal';
import { ADDRESS, APPLICATION_STEPS, MAIL_CARD } from '#client/constants/application';
import useCardsContext from '#client/hooks/useCardsContext';
import { FormStepProvider } from '#client/hooks/useFormStep';
import useToastContext from '#client/hooks/useToastContext';

import MailCard from './components/MailCard';

export default function OpenDebitCardMailing({ handleClose, steps = APPLICATION_STEPS }) {
  const [currentFormStep, setCurrentFormStep] = useState(MAIL_CARD);
  const [formData, setFormData] = useState({
    addressType: ADDRESS.BUSINESS
  });
  const { physicalCard, cardsLoading, cardsError } = useCardsContext();
  const { createCommonErrorToast } = useToastContext();

  useEffect(() => {
    if (!cardsLoading && physicalCard) {
      handleClose();
    }

    if (cardsError) {
      createCommonErrorToast({ error: cardsError });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardsLoading, physicalCard, cardsError]);

  if (cardsLoading) {
    return null;
  }

  return (
    <FormStepModal
      currentStep={currentFormStep}
      handleClose={handleClose}
      isHideBackButton
      stepNames={steps}
      title="Open a business bank account"
    >
      <FormStepProvider
        value={{
          currentFormStep,
          setCurrentFormStep,
          data: formData,
          setData: setFormData
        }}
      >
        {currentFormStep === MAIL_CARD && <MailCard />}
      </FormStepProvider>
    </FormStepModal>
  );
}

OpenDebitCardMailing.propTypes = {
  handleClose: PropTypes.func.isRequired,
  steps: PropTypes.arrayOf(PropTypes.string)
};
